// tslint:disable-next-line: no-submodule-imports
import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { InfiniteLoader, List, WindowScroller } from 'react-virtualized';
import { computeContainerWidth } from '../../../utils/gridHelpers';
import LoadingWidget from '../../LoadingWidget';
import * as infiniteListStyles from './InfiniteList.scss';
const Item = SortableElement((props) => {
    const { track, handleSelected, TagType, loading } = props;
    const { index, rowIndex, key, style } = props;
    return (React.createElement(TagType, { style: style, loading: loading, data: track, handleSelected: handleSelected, index: index || rowIndex, key: key }));
});
class InfiniteList extends React.Component {
    constructor() {
        super(...arguments);
        this.renderRow = (props) => {
            const { index } = props;
            const track = Object.assign({}, (this.props.data.items[index] || { placeholder: true }));
            const allProps = Object.assign(Object.assign({ track, rowIndex: props.index, TagType: this.props.componentType, disabled: !this.props.isDragAndDropEnabled }, props), this.props);
            return React.createElement(Item, Object.assign({}, allProps));
        };
    }
    render() {
        var _a, _b;
        // Grab data from props and Redux store.
        const { windowWidth } = this.props;
        const { items, onEndOfWidget } = this.props.data;
        const width = computeContainerWidth(windowWidth || 0);
        // Find the number of items to render.
        const count = items.length;
        // Functions to check when to load more items.
        const loadMore = () => this.props.handleSelected(onEndOfWidget);
        // InfiniteLoader will call loadMoreRows callback when isRowLoaded returns false. We now say the last row
        // is "not loaded" so InfiniteLoader will call loadMoreRows when we get to the last row, if we know onEndOfWidget
        // exists.
        const isItemLoaded = ({ index }) => { var _a; return index < (((_a = onEndOfWidget) === null || _a === void 0 ? void 0 : _a.length) ? items.length - 1 : items.length); };
        const rootScroller = ((_a = this.props) === null || _a === void 0 ? void 0 : _a.isVisualPlayQueue) ? document.getElementById('playqueue') : undefined;
        const showLoader = ((_b = onEndOfWidget) === null || _b === void 0 ? void 0 : _b.length) > 0;
        return (React.createElement("div", { className: infiniteListStyles.infiniteList },
            React.createElement(InfiniteLoader, { isRowLoaded: isItemLoaded, loadMoreRows: loadMore, rowCount: count }, ({ onRowsRendered }) => (React.createElement(WindowScroller, { scrollElement: rootScroller }, ({ height, scrollTop, registerChild }) => {
                var _a;
                return (
                // Here's some documentation as to why this works:
                // https://github.com/bvaughn/react-virtualized/issues/1324
                // https://github.com/bvaughn/react-virtualized/blob/master/docs/WindowScroller.md#render-props
                React.createElement("div", { ref: el => registerChild(el), className: infiniteListStyles.removeOutline },
                    React.createElement(List, { items: items, componentType: this.props.componentType, loading: (_a = this.props) === null || _a === void 0 ? void 0 : _a.loading, onRowsRendered: onRowsRendered, handleSelected: this.props.handleSelected, autoHeight: true, height: height, rowCount: count, rowHeight: this.props.rowHeight, rowRenderer: this.renderRow, scrollTop: scrollTop, width: width, overscanRowCount: 5 })));
            }))),
            showLoader && React.createElement(LoadingWidget, null)));
    }
}
;
function mapStateToProps(state) {
    return {
        windowWidth: state.BrowserState.windowWidth,
    };
}
function mapDispatchToProps(dispatch) {
    return {};
}
const SortableVirtualList = SortableContainer(connect(mapStateToProps, mapDispatchToProps)(withStyles(infiniteListStyles)(InfiniteList)));
// tslint:disable-next-line: max-classes-per-file
export default class SortableComponent extends React.Component {
    constructor(props) {
        super(props);
        this.registerListRef = function (sortableList, listInstance) {
            if (this) {
                this.List = listInstance;
            }
            if (sortableList) {
                sortableList.List = listInstance;
            }
        };
        this.isDragAndDropEnabled = () => {
            return !!(this.props.handleReorder && this.props.handleReorder.length > 0);
        };
        this.setState({ 'isDragging': false });
    }
    render() {
        var _a, _b, _c, _d;
        if (this.state.isDragging) {
            (_b = (_a = this.List) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.classList.add(infiniteListStyles.isDragging);
        }
        else {
            (_d = (_c = this.List) === null || _c === void 0 ? void 0 : _c.container) === null || _d === void 0 ? void 0 : _d.classList.remove(infiniteListStyles.isDragging);
        }
        return React.createElement(SortableVirtualList, Object.assign({ ref: this.registerListRef.bind(null, this) }, this.props, { transitionDuration: 100, 
            // tslint:disable-next-line: jsx-no-bind
            onSortStart: this.dragStart.bind(this), 
            // tslint:disable-next-line: jsx-no-bind
            onSortEnd: this.dragEnd.bind(this), helperClass: infiniteListStyles.dragHelper, distance: 15, 
            // @ts-ignore
            isDragAndDropEnabled: this.isDragAndDropEnabled(), useWindowAsScrollContainer: true, hideSortableGhost: true, lockAxis: 'y' }));
    }
    dragStart() {
        this.setState({ 'isDragging': true });
    }
    dragEnd({ oldIndex, newIndex }) {
        var _a, _b, _c;
        this.setState({ 'isDragging': false });
        if (newIndex === oldIndex) {
            return;
        }
        (_b = (_a = this.props).handleReorder) === null || _b === void 0 ? void 0 : _b.call(_a, newIndex, oldIndex);
        (_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.blur();
    }
}
